module.exports = __webpack_public_path__ + "static/media/canaanite_text_03.47c4771e.png";